var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "attribute-picker" },
    [
      _c("div", { staticClass: "search-panel" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText",
            },
          ],
          attrs: {
            maxlength: "128",
            placeholder: _vm.$t("chatbotv2.typeSearchValue"),
            type: "text",
          },
          domProps: { value: _vm.searchText },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchText = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btnGroup" },
        _vm._l(_vm.allowedContexts, function (context) {
          return _c(
            "SupsisButton",
            {
              key: context,
              attrs: {
                classNames:
                  _vm.selectedContext === context
                    ? "btnGroupItem selected"
                    : "btnGroupItem ",
                primary: _vm.selectedContext === context,
                ghost: _vm.selectedContext !== context,
                small: "",
              },
              on: {
                click: function () {
                  return _vm.changeSelectedContext(context)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$_.startCase(context)) +
                  "\n        "
              ),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.selectedContext === "general"
        ? _c(
            "div",
            { staticClass: "attribute-list" },
            [
              !_vm.filterAttributes().length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-center text-center align-items-center mb-5",
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.noResultFound"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("custom").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.whatsappMode
                                  ? "Whatsapp Contact Attributes"
                                  : _vm.$t("chatbotv2.CUSTOM_ATTRIBUTES")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filterAttributes("custom"), function (attr) {
                        return _c(
                          "div",
                          {
                            staticClass: "picker-item",
                            class: {
                              active: _vm.defaultSelected === attr.name,
                            },
                            attrs: {
                              "data-checked": "true",
                              "data-index": "0",
                              "data-item-label": "Name",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(attr.value)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v(" data_object "),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.isLocalizedAttribute(attr.name)
                                      ? _vm.$t("chatbotv2.attr." + attr.name)
                                      : attr.name
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "description" }, [
                              _vm._v(" " + _vm._s(attr.placeholder) + " "),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "attr-select" },
                [
                  _vm.filterAttributes("system").length
                    ? _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("chatbotv2.USER_DATA")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.filterAttributes("system"), function (attr) {
                    return _c(
                      "div",
                      {
                        staticClass: "picker-item",
                        class: { active: _vm.defaultSelected === attr.value },
                        attrs: {
                          "data-checked": "true",
                          "data-index": "0",
                          "data-item-label": "Name",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.pick(attr.value)
                          },
                        },
                      },
                      [
                        _c("AttributeIconPreview", {
                          attrs: { attribute: attr.value },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.isLocalizedAttribute(attr.value)
                                  ? _vm.$t("chatbotv2.attr." + attr.value)
                                  : attr.value
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "description" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                attr.placeholder == "Turkey" &&
                                  attr.placeholder == "Male"
                                  ? _vm.$t(
                                      "chatbotv2." +
                                        attr.placeholder.toLocaleLowerCase()
                                    )
                                  : attr.placeholder
                              ) +
                              "\n                "
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.filterAttributes("visitorContactProperty").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                VISITOR CONTACT PROPERTIES\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.filterAttributes("visitorContactProperty"),
                        function (attr) {
                          return _c(
                            "div",
                            {
                              staticClass: "picker-item",
                              class: {
                                active: _vm.defaultSelected === attr.value,
                              },
                              attrs: {
                                "data-checked": "true",
                                "data-index": "0",
                                "data-item-label": "Name",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pick(attr.value)
                                },
                              },
                            },
                            [
                              _c("AttributeIconPreview", {
                                attrs: { attribute: "object" },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(attr.name) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "description" }, [
                                _vm._v(" " + _vm._s(attr.placeholder) + " "),
                              ]),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("ai-function").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [_vm._v("\n                AI FUNCTION\n            ")]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.filterAttributes("ai-function"),
                        function (attr) {
                          return _c(
                            "div",
                            {
                              staticClass: "picker-item",
                              class: {
                                active: _vm.defaultSelected === attr.value,
                              },
                              attrs: {
                                "data-checked": "true",
                                "data-index": "0",
                                "data-item-label": "Name",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pick(attr.value)
                                },
                              },
                            },
                            [
                              _c("AttributeIconPreview", {
                                attrs: { attribute: "object" },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(attr.name) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "description" }, [
                                _vm._v(" " + _vm._s(attr.placeholder) + " "),
                              ]),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("akinon").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                AKINON ATTRIBUTES\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filterAttributes("akinon"), function (attr) {
                        return _c(
                          "div",
                          {
                            staticClass: "picker-item",
                            class: {
                              active: _vm.defaultSelected === attr.name,
                            },
                            attrs: {
                              "data-checked": "true",
                              "data-index": "0",
                              "data-item-label": "Name",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(attr.value)
                              },
                            },
                          },
                          [
                            _c("AttributeIconPreview", {
                              attrs: { attribute: attr.value },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.isLocalizedAttribute(attr.value)
                                      ? _vm.$t("chatbotv2.attr." + attr.value)
                                      : attr.value
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "description" }, [
                              _vm._v(" " + _vm._s(attr.placeholder) + " "),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("ideasoft").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                IDEASOFT ATTRIBUTES\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filterAttributes("ideasoft"), function (attr) {
                        return _c(
                          "div",
                          {
                            staticClass: "picker-item",
                            class: {
                              active: _vm.defaultSelected === attr.name,
                            },
                            attrs: {
                              "data-checked": "true",
                              "data-index": "0",
                              "data-item-label": "Name",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(attr.value)
                              },
                            },
                          },
                          [
                            _c("AttributeIconPreview", {
                              attrs: { attribute: attr.value },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.isLocalizedAttribute(attr.value)
                                      ? _vm.$t("chatbotv2.attr." + attr.value)
                                      : attr.value
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "description" }, [
                              _vm._v(" " + _vm._s(attr.placeholder) + " "),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("probel").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                PROBEL ATTRIBUTES\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filterAttributes("probel"), function (attr) {
                        return _c(
                          "div",
                          {
                            staticClass: "picker-item",
                            class: {
                              active: _vm.defaultSelected === attr.name,
                            },
                            attrs: {
                              "data-checked": "true",
                              "data-index": "0",
                              "data-item-label": "Name",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(attr.value)
                              },
                            },
                          },
                          [
                            _c("AttributeIconPreview", {
                              attrs: { attribute: attr.value },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.isLocalizedAttribute(attr.value)
                                      ? _vm.$t("chatbotv2.attr." + attr.value)
                                      : attr.value
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "description" }, [
                              _vm._v(" " + _vm._s(attr.placeholder) + " "),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("b2cargo").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                B2CARGO ATTRIBUTES\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filterAttributes("b2cargo"), function (attr) {
                        return _c(
                          "div",
                          {
                            staticClass: "picker-item",
                            class: {
                              active: _vm.defaultSelected === attr.name,
                            },
                            attrs: {
                              "data-checked": "true",
                              "data-index": "0",
                              "data-item-label": "Name",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(attr.value)
                              },
                            },
                          },
                          [
                            _c("AttributeIconPreview", {
                              attrs: { attribute: attr.value },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.isLocalizedAttribute(attr.value)
                                      ? _vm.$t("chatbotv2.attr." + attr.value)
                                      : attr.value
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "description" }, [
                              _vm._v(" " + _vm._s(attr.placeholder) + " "),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("holiday_plus").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                HOLIDAY+ ATTRIBUTES\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.filterAttributes("holiday_plus"),
                        function (attr) {
                          return _c(
                            "div",
                            {
                              staticClass: "picker-item",
                              class: {
                                active: _vm.defaultSelected === attr.name,
                              },
                              attrs: {
                                "data-checked": "true",
                                "data-index": "0",
                                "data-item-label": "Name",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pick(attr.value)
                                },
                              },
                            },
                            [
                              _c("AttributeIconPreview", {
                                attrs: { attribute: attr.value },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.isLocalizedAttribute(attr.value)
                                        ? _vm.$t("chatbotv2.attr." + attr.value)
                                        : attr.value
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "description" }, [
                                _vm._v(" " + _vm._s(attr.placeholder) + " "),
                              ]),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterAttributes("trendyol").length
                ? _c(
                    "div",
                    { staticClass: "attr-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tpl-category-select-category-name",
                          attrs: {
                            "text-color": "lighter",
                            "text-weight": "semi-bold",
                            "text-type": "h5",
                          },
                        },
                        [
                          _vm._v(
                            "\n                TRENDYOL ATTRIBUTES\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filterAttributes("trendyol"), function (attr) {
                        return _c(
                          "div",
                          {
                            staticClass: "picker-item",
                            class: {
                              active: _vm.defaultSelected === attr.name,
                            },
                            attrs: {
                              "data-checked": "true",
                              "data-index": "0",
                              "data-item-label": "Name",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(attr.value)
                              },
                            },
                          },
                          [
                            _c("AttributeIconPreview", {
                              attrs: { attribute: attr.value },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.isLocalizedAttribute(attr.value)
                                      ? _vm.$t("chatbotv2.attr." + attr.value)
                                      : attr.value
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "description" }, [
                              _vm._v(" " + _vm._s(attr.placeholder) + " "),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              !_vm.whatsappMode
                ? _c("AddCustomAttribute", { attrs: { "on-added": _vm.pick } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "table"
        ? _c("TableAttributePicker", { attrs: { "on-picked": _vm.pick } })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedContext === "api"
        ? _c("APIAttributePicker", { attrs: { "on-picked": _vm.pick } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }